import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type PropsWithChildren } from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // data younger than this satisfies new mounts and window-focus refetches without a request;
      // freshness comes from the pollers' refetchInterval and the post-transaction refetch trigger
      staleTime: 30_000,
      retry: 2,
    },
  },
});

export const ReactQueryProvider = ({ children }: PropsWithChildren) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
